import { render, staticRenderFns } from "./InceptionRecruiterDashboard.vue?vue&type=template&id=6a96eaf0&scoped=true"
import script from "./InceptionRecruiterDashboard.vue?vue&type=script&lang=ts"
export * from "./InceptionRecruiterDashboard.vue?vue&type=script&lang=ts"
import style0 from "./InceptionRecruiterDashboard.vue?vue&type=style&index=0&id=6a96eaf0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a96eaf0",
  null
  
)

export default component.exports